import Vue from 'vue'

export default {
    list(params) {
        return Vue.axios.get(`/streets`, {params})
    },
    create(params) {
        return Vue.axios.post(`/streets/create`, params)
    },
    update(params) {
        return Vue.axios.post(`/streets/update`, params)
    },
    remove(id) {
        return Vue.axios.get(`/streets/remove/${id}`)
    },
    get(id) {
        return Vue.axios.get(`/streets/${id}`)
    },
    // create() {
    //     return Vue.aiox.post('/api/posts')
    // }
    // // etc
}
